import React, { useContext } from "react"
import { AppContext } from '../App'


function GuessText({ attemptNum }) {
    const { rows } = useContext(AppContext)

    let guessString = rows[attemptNum]

    return (
        <div className="letter">
            {guessString}
        </div>
    )
}

export default GuessText